module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app-header"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "app-header__row"
  }, [_c('logo', {
    staticClass: "logo-app-header"
  }), _vm._v(" "), (_vm.isRaceLive) ? _c('div', {
    staticClass: "race-status"
  }, [_vm._v("📢 Live Now")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "main"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n          Trainer Console\n        ")]), _vm._v(" "), _c('ul', [_c('li', [_c('router-link', {
    attrs: {
      "to": "/admin/live-run"
    }
  }, [_vm._v("Liverun")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/admin/races"
    }
  }, [_vm._v("Schedule")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/admin/past-run"
    }
  }, [_vm._v("Past Runs")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/admin/scheduled-runs"
    }
  }, [_vm._v("Scheduled Runs")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/admin/runners/allrunners"
    }
  }, [_vm._v("Runners")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/admin/trainers"
    }
  }, [_vm._v("Trainers")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/admin/medal"
    }
  }, [_vm._v("Medal")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/admin/settings"
    }
  }, [_vm._v("Settings")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/admin/TP"
    }
  }, [_vm._v("TP")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/admin/AR&TD"
    }
  }, [_vm._v("AR&TD")])], 1), _vm._v(" "), _c('li', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selected),
      expression: "selected"
    }],
    staticClass: "more-select",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.selected = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        return _vm.handleSelect()
      }]
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "disabled": "",
      "selected": ""
    }
  }, [_vm._v("More")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "promo-codes"
    }
  }, [_vm._v("Promo Codes")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "logs"
    }
  }, [_vm._v("Logs")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "mongodb"
    }
  }, [_vm._v("MongoDB")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "firebase-stats"
    }
  }, [_vm._v("Firebase")])])])])]), _vm._v(" "), _c('user-info')], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5f120cf0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/AppHeader/AppHeader.vue
// module id = 1675
// module chunks = 2